import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';



import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class ModellerGuard  {
  constructor(private _authService: AuthService, private _router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this._authService._loggedIn$.value) {
      if (this._authService.userHasAccessToDatasetAdmin) {
        return true;
      }
      else {
        return this._router.parseUrl('access-denied');
      }
    }
    else {
       this._router.navigate(['login'])
       return false;
    }
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return (this._authService.userHasAccessToDatasetAdmin)!;
  }
}
